import Linked from 'shared-components/service/Linked'
import styles from './SectionHeader.module.css'

interface SectionHeaderProps {
  title: string
  /** Optional right-aligned link. `external` (default true) opens in a new tab. */
  link?: { href: string; label: string; external?: boolean; onClick?: () => void }
  /** Optional supporting line shown under the heading. */
  intro?: string
  /** 'lg' for pages where these are the main section titles (e.g. /compare). */
  size?: 'lg'
}

/** Shared eyebrow section heading (+ optional link / intro) for product-page sections. */
const SectionHeader: React.VFC<SectionHeaderProps> = ({ title, link, intro, size }) => {
  const header = (
    <>
      <div className={styles.head}>
        <h2 className={styles.heading} data-size={size}>
          {title}
        </h2>
        {link && (
          <Linked
            href={link.href}
            className={styles.headLink}
            onClick={link.onClick}
            {...(link.external === false ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
          >
            {link.label}
          </Linked>
        )}
      </div>
      {intro && (
        <p className={styles.intro} data-size={size}>
          {intro}
        </p>
      )}
    </>
  )
  // 'lg' headers sit in flex-gap sections; one box keeps the intro tight under the title.
  return size === 'lg' ? <div>{header}</div> : header
}

export default SectionHeader
